import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative w-full overflow-hidden rounded-[20px]',
    content:
      'absolute top-1/2 aspect-auto max-w-[70%] -translate-y-1/2 transform pl-6 lg:max-w-126 lg:pl-12',
    image: 'h-50 w-full object-cover lg:h-40',
    button: 'heading-xs-bold m-0 justify-start pl-0 tracking-wider',
    buttonContent: 'flex gap-2'
  }
});
